import { HttpParams } from '@angular/common/http';

export function makeHttpParams(input?: any): HttpParams {
  if (!input || typeof (input) !== 'object') {
    return new HttpParams();
  }

  return new HttpParams({
    fromObject: Object.keys(input)
      .filter(k => typeof(input[k]) !== 'undefined')
      .reduce((params, cur) => {
        params[cur] = input[cur];
        return params;
      }, {}),
  });
}
